import React, { useState } from 'react';
import { Alert, Modal, Button } from 'react-bootstrap';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const ExamDeleteLink = (props: {
  examId: string | undefined;
  examNumber: number | undefined;
}) => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const [saveErrors, setSaveErrors] = useState<string[]>([]);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleOnDelete = async () => {
    if (props.examId) {
      try {
        await spd.exams.changeToInactive(props.examId);
        void nav.exams();
      } catch (response) {
        const errors = await responseErrors(response as ResponseError);
        setSaveErrors(errors);
        setShowErrorModal(true);
      }
    }
  };

  return (
    <div>
      <ConfirmationButton
        className="ms-1"
        confirmation={`Czy na pewno usunąć badanie ${
          props.examNumber || ''
        } razem z wynikami i wydrukami?`}
        variant="outline-danger"
        onOK={handleOnDelete}
      >
        Usuń badanie
      </ConfirmationButton>
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
      >
        <Modal.Body>
          <Alert variant="danger" className="m-0">
            {saveErrors.map((e, i) => (
              <div key={i}>{e}</div>
            ))}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-danger"
            onClick={() => setShowErrorModal(false)}
          >
            Zamknij
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
